import { render, staticRenderFns } from "./19.vue?vue&type=template&id=349f79da&scoped=true&"
import script from "./19.vue?vue&type=script&lang=js&"
export * from "./19.vue?vue&type=script&lang=js&"
import style0 from "./19.vue?vue&type=style&index=0&id=349f79da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349f79da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
